<ng-container *transloco="let t;">
  <div class="shared-vehicles-filter material-radio-button">
    <mat-radio-group
      [value]="selectedValue$()"
      class="shared-vehicles-radio-group"
    >
      <!-- All Recipients Radio Button -->
      <div class="filter-option mb-2">
        <mat-radio-button
          class="_mat-animation-noopable"
          [value]="'all'"
          [disableRipple]="true"
          (change)="selectAllRecipients()"
          [aria-label]="t('sellModule.manageInventory.searchFilter.labelAllRecipients')"
          data-test-id="app-shared-vehicles-filter-all-recipients"
        >
          {{ t('sellModule.manageInventory.searchFilter.labelAllRecipients') }}
        </mat-radio-button>
      </div>
      <!-- Dealer Sections -->
      @if (offerLists) {
        @for (dealer of offerLists | slice: 0:(showAllOfferListRecipients$()
          ? offerLists.length : 9); track dealerListById(i, dealer); let i = $index) {
          <div class="dealer-section ms-2 mb-3">
            <app-search-filter-section
              [title]="dealer.name"
              variant="link"
              [analyticsName]="'Buying Dealer Name (accordion)'"
              [open]="isOfferListDealershipDropdownOpen(dealer.value)"
              (openChange)="toggleOfferListDealershipDropdown(dealer.value)"
            >
              @if (isOfferListDealershipDropdownOpen(dealer.value)) {
                <div class="dealer-content ms-3 mt-2">
                  @for (recipient of dealer.userNameUuid; track recipient; let j = $index) {
                    <div class="shared-list-recipient-section mb-2">
                      <!-- Recipient Label -->
                      <label class="shared-list-recipient-label d-block mb-1">
                        {{ recipient.name }}
                      </label>

                      <!-- All Lists Radio Button for Recipient -->
                      <div class="filter-option mb-1 ms-2">
                        <mat-radio-button
                          class="_mat-animation-noopable"
                          [value]="'recipient:' + dealer.value + ':' + recipient.value"
                          [disableRipple]="true"
                          (change)="selectRecipientAllLists(dealer.value, recipient.value, recipient.offerListUuid)"
                          [aria-label]="t('sellModule.manageInventory.searchFilter.labelAllList') + ' - ' + recipient.name"
                          [attr.data-test-id]="'app-shared-vehicles-filter-recipient-all-lists-' + recipient.value"
                        >
                          {{ t('sellModule.manageInventory.searchFilter.labelAllList') }}
                        </mat-radio-button>
                      </div>

                      <!-- Individual Offer List Radio Buttons -->
                      @for (offerList of recipient.offerListUuid; track offerList; let l = $index) {
                        <div class="filter-option mb-1 ms-2">
                          <mat-radio-button
                            class="_mat-animation-noopable"
                            [value]="'offerList:' + offerList.value"
                            [disableRipple]="true"
                            (change)="selectOfferList(offerList.value)"
                            [aria-label]="offerList.name"
                            [attr.data-test-id]="'app-shared-vehicles-filter-offer-list-' + offerList.value"
                          >
                            {{ offerList.name }}
                          </mat-radio-button>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </app-search-filter-section>
          </div>
        }
      }

      <!-- Show All / Show Less Button -->
      @if (offerLists.length > 9) {
        <button
          type="button"
          data-track-elem="button"
          [id]="offerListShowAllDataTrackId()"
          class="btn btn-link p-0 mt-2 ms-2"
          (click)="toggleShowAllOfferListRecipients()"
        >
          {{ showAllOfferListsRecipientsText$() }}
        </button>
      }
    </mat-radio-group>
  </div>
</ng-container>
